<template>
  <div class="section-layout">
    <div v-for="(section, k) in sections" :key="k" class="col-12 col-md-12 px-0 layout-section">
      <div class="mr-md-4 pb-2 rounded">
        <div v-if="section !== 'untitled'" class="section-heading-top py-2 mt-1 mb-2 pl-2 product-section-heading text-white rounded-top">
            <section-heading :section="section" :pageData="pageData" :headingType="'top'"></section-heading>
        </div>

      <!-- Unnamed subSection block -->
      <div class="scrolling-wrapper pt-3 bg-white">
        <div v-for="(subSection, k) in subSections" :key="k" v-if="group[section][subSection] && subSection === 'untitled'" class="cardItem col-md-3">
            <form-block v-for="(fieldData, m) in group[section][subSection]['untitled']" :key="m"
              :formdata="fieldData"
              :formIndex="m"
              class="form-group mx-3"></form-block>
        </div>
      </div>
      <!-- Unnamed subSection block END -->

    <template>
      <!-- Top scroll bar START -->
      <!-- This is for the top scroll bar. It will match the width of the actual carousel -->
      <div id="carousel-vehicle-top-scrollbar" ref="carousel-vehicle-top-scrollbar" class="scrolling-wrapper pb-2 bg-white">
        <div v-for="(subSection, j) in subSections" :key="j" v-if="group[section][subSection] && subSection !== 'untitled'" class="cardItem col-md-3">
        </div>
      </div>
      <!-- Top scroll bar END -->

      <!-- Column headings START -->
      <div id="carousel-vehicle-headings" ref="carousel-vehicle-headings" class="scrolling-wrapper pt-3 bg-white">
        <div v-for="(subSection, k) in subSections" :key="k" v-if="group[section][subSection] && subSection !== 'untitled'" class="cardItem col-md-3">
          <div class="form-row py-2 pl-3 mx-0 product-subsection-heading  rounded-top h-100">
            <div class="col p-0">
              <div>
                  <div role="heading" aria-level="4">{{ subSection }}</div>
                  <a href="javascript:void(0);" class="delete"
                    @keydown.enter.prevent.stop="promptDeleteSection(`remove-claim-modal_${k}`)"
                    @keydown.space.prevent.stop="promptDeleteSection(`remove-claim-modal_${k}`)"
                    @click.prevent="promptDeleteSection(`remove-claim-modal_${k}`)"
                    :aria-label="ariaLabel(subSection)"></a>
              </div>
            </div>
          </div>
            <!--  remove modal -->
          <div>
            <b-modal :ref="`remove-claim-modal_${k}`" hide-header hide-footer hide-header-close no-enforce-focus>
              <Trapclaim :group="`remove-modal`">
                <div class="remove-confirmation-box">
                  <div class="remove-modal-message mb-3">
                    <div>Are you sure you want to remove this claim?</div>
                  </div>
                  <div class="remove-modal-sep mt-1 mb-1"></div>
                  <div class="remove-btn-box">
                    <b-button class="mt-3 remove-btn-cancel remove-cust-btn" block
                    @keydown.enter.prevent.stop="closeRemoveModalProperty(`remove-claim-modal_${k}`)"
                    @keydown.space.prevent.stop="closeRemoveModalProperty(`remove-claim-modal_${k}`)" @click="closeRemoveModalProperty(`remove-claim-modal_${k}`)">Cancel</b-button>
                    <b-button class="mt-3 remove-btn-confirm remove-cust-btn" block @keydown.enter.prevent.stop="deleteSection(subSection, `remove-claim-modal_${k}`)"
                    @keydown.space.prevent.stop="deleteSection(subSection, `remove-claim-modal_${k}`)" @click="deleteSection(subSection, `remove-claim-modal_${k}`)">
                      Remove</b-button>
                  </div>
                </div>
              </Trapclaim>
            </b-modal>
          </div>
        </div>
      </div>
      <!-- Column headings END -->

      <div class="container-fluid" style="margin-top: 0">
        <div id="carousel-vehicle" ref="carousel-vehicle" class="row scrolling-wrapper pb-3">
          <div v-for="(subSection, l) in subSections" :key="l" v-if="group[section][subSection] && subSection !== 'untitled'" class="cardItem col-md-3 mb-3">
              <div class="form-row mx-0 pt-3 accordPanel shadow-sm rounded-bottom">
                <div class="col-12 px-0">
                  <!--VEHICLE SECTION HEADER-->
                  <!--START VEHICLE SECTION CONTAINER-->
                  <div class="form-row ml-3 mr-0">
                    <div class="col-12 px-0">

                      <div>
                        <div v-for="(subSubSection, l) in subSubSections" :key="l" v-if="group[section][subSection][subSubSection]"
                          :class="(subSubSection === 'untitled' ? 'col-md-12 px-0' : 'col-12 col-lg-6 px-0 mb-3')">
                          <div v-if="subSubSection !== 'untitled'">
                            <div class="form-row mx-0">
                              <div class="col py-1 pl-2 my-2 ml-3 bg-ltblue text-white">
                                <div>{{ subSubSection }}</div>
                              </div>
                            </div>
                          </div>

                          <form-block v-for="(fieldData, m) in group[section][subSection][subSubSection]" :key="m"
                            :formdata="fieldData"
                            :formIndex="m"
                            class="form-group mx-3"></form-block>
                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="form-row py-3 mx-0 mt-4 product-subsection-heading rounded-bottom">
                    <div class="col p-0 text-right mr-3 smaller-font-content">
                    </div>
                  </div>
                </div>
            </div>

          </div>
        </div>
      </div>
    </template>
      </div>

      <div v-if="section !== 'untitled'" class="section-heading-bottom py-2 mt-1 mb-2 pl-2 text-white rounded-top">
          <section-heading :section="section" :pageData="pageData" :headingType="'bottom'"></section-heading>
      </div>
    </div>
  </div>
</template>

<script>
/* global gtag */
import Trapclaim from 'vue-focus-lock';
import commonService from '../../../services/common';
import axios from '../../../axios-config';
import FieldDisplay from '../FieldDisplay';
import SectionHeading from '../SectionHeading';
import FormBlock from '../FormBlock';
import { layoutOptions } from '../../../mixins/layoutOptions';
import { rulesMixin } from '../../../mixins/rulesMixin';
import { layout } from '../../../mixins/layout';

export default {
  props: ['group'],
  inject: ['$validator'],
  mixins: [
    rulesMixin,
    layout,
    layoutOptions,
  ],
  data() {
    return {
      sections: [],
      subSections: [],
      subSubSections: [],
      layout: null,
    };
  },
  components: {
    FieldDisplay,
    SectionHeading,
    FormBlock,
    Trapclaim,
  },
  methods: {
    /**
     * Remove duplicate values from an array.
     *
     * This is necessary to avoid repeating the 'untitled' value that represents
     * sections that do not have a name. Since all of the data is nested within
     * a section, a subsection, and a subsubsection, each needs a name to group
     * the fields together under their respective hierarchy. If, in the future,
     * the data is received in the tree structure it is supposed to be represented
     * as, then this and other steps are not necessary.
     */
    removeDuplicateValues(section) {
      return section.filter((item, pos, self) => self.indexOf(item) === pos);
    },
    compileSectionNames() {
      /* eslint-disable no-restricted-syntax, no-prototype-builtins */

      for (const section in this.group) {
        if (this.group.hasOwnProperty(section)) {
          if (!this.sections[section]) {
            this.sections.push(section);
          }

          for (const subSection in this.group[section]) {
            if (this.group[section].hasOwnProperty(subSection)) {
              if (!this.subSections[subSection]) {
                this.subSections.push(subSection);
              }

              for (const subSubSection in this.group[section][subSection]) {
                if (this.group[section][subSection].hasOwnProperty(subSubSection)) {
                  if (!this.subSubSections[subSubSection]) {
                    this.subSubSections.push(subSubSection);
                  }
                }
              }
            }
          }
        }
      }
      console.log('this group date in layout horizontal', this.group);
      this.sections = this.removeDuplicateValues(this.sections);
      this.subSections = this.removeDuplicateValues(this.subSections);
      this.subSubSections = this.removeDuplicateValues(this.subSubSections);
    },
    ariaLabel(section) {
      return `Remove ${section}`;
    },
    deleteSection(section, removeModal) {
      const pageData = this.$store.state.updatePageData.pageData;
      const buttons = pageData.section_buttons || [];

      const sectionButtons = buttons.filter(button => button.section === section);
      const sectionButton = sectionButtons.shift(); // Since IE11 does not support .find() .
      this.$refs[removeModal][0].hide();
      axios.post(
        sectionButton.on_click, // API endpoint URL
        {
          fields: commonService.getFormData(this.pageData), // All of the current `pageData` fields
          page_name: this.pageData.page_name, // Current `pageData` `page_name`
          session_id: this.$store.getters.getSessionID, // Current Session ID
        },
      ).then(() => {
        this.$router.go(0); // TODO: Update API to respond with which fields to remove, and remove those
      }).catch((error) => {
        // TODO: Use response (data or http code) to evaluate error

        window.console.warn('An error occurred while requesting a section button post:', error);
        gtag('event', 'exception', {
          description: 'Error requesting section button quote',
          fatal: false, // set to true if the error is fatal
        });
      });
    },
    promptDeleteSection(sectionModal) {
      // updates: changed implementation for accessibility ticket as below implementation not providing more control over html
      // TODO: Use config values
      /* const options = {
        okText: 'Remove',
        cancelText: 'Cancel',
        html: true,
        animation: 'zoom',
        backdropClose: true,
      };
      // TODO: Use config values
      this.$dialog
        .confirm('Are you sure you want to remove this claim?', options)
        .then(() => {
          window.console.info('Delete section:', section);
          this.deleteSection(section);
        })
        .catch(() => {
          window.console.info('Did not delete section:', section);
        }); */
      this.$refs[sectionModal][0].show();
    },
  },
  mounted() {
    this.compileSectionNames();
  },
  updated() {
    // TODO: Execute this code after these elements have been added to the DOM
    const carouselVehicleTopScrollbar = document.getElementById('carousel-vehicle-top-scrollbar');
    const carouselVehicle = document.getElementById('carousel-vehicle');
    const carouselVehicleHeadings = document.getElementById('carousel-vehicle-headings');

    if (carouselVehicleTopScrollbar && carouselVehicle && carouselVehicleHeadings) {
      carouselVehicleTopScrollbar.onscroll = () => {
        carouselVehicle.scrollLeft = carouselVehicleTopScrollbar.scrollLeft;
        carouselVehicleHeadings.scrollLeft = carouselVehicleTopScrollbar.scrollLeft;
      };
      carouselVehicle.onscroll = () => {
        carouselVehicleTopScrollbar.scrollLeft = carouselVehicle.scrollLeft;
        carouselVehicleHeadings.scrollLeft = carouselVehicle.scrollLeft;
      };
      carouselVehicleHeadings.onscroll = () => {
        carouselVehicleTopScrollbar.scrollLeft = carouselVehicleHeadings.scrollLeft;
        carouselVehicle.scrollLeft = carouselVehicleHeadings.scrollLeft;
      };

      // TODO: Don't check user agent since it is not always reliable
      // Hides horizontal scroll bar on column headings
      if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1) {
        carouselVehicleHeadings.classList.add('hide-x-scroll');
      }
    }

    /* eslint no-undef: */
    /* eslint prefer-template:  */
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

#carousel-vehicle-headings {
    -ms-overflow-style: none;
}

#carousel-vehicle-headings::-webkit-scrollbar {
    display: none;
}

.scrolling-wrapper .cardItem {
  flex: 0 0 auto;
}

.scrolling-wrapper::-webkit-scrollbar {
  width: 20px;
}

.scrolling-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  background: #FFFFFF;
}

.scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.scrolling-wrapper .cardItem {
  flex: 0 0 auto;
}

.scrolling-wrapper .cardItem.col-md-3 {
  max-width: 400px !important;
  padding: 0 0.5rem !important;
}

#carousel-vehicle-headings .cardItem,
#form-container.fixed-top.fixed-to-nav {
  background: rgba(255, 255, 255, 0);
}

.list-item {
  display: inline-block;
  width: auto;
  height: auto;
  min-height: auto;
  float: none;
  margin: 0.25rem 0.25rem;
}

.vd-btn.list-item .delete{
  display: inline-block;
  position: absolute;
  right: -10px;
  top: -10px;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  line-height: 1em;
  cursor: pointer;
}

.vehicle-check-polk {
  display: block;
  position: absolute;
  right:-13px;
  bottom: -3px;
  width: 20px;
  height: 20px;
}

.hide-x-scroll {
  overflow-x: hidden;
}

/***header/footer information blurb***/
@media all and (max-width: 992px) {
  .alert.alert-primary{
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/layouts/LayoutHorizontal.vue?c75add32